/**
 * 外觀 - 角標 - 教會
 */
export const EnumVariantBadgeChurch = Object.freeze({

    /**
     * 編號
     */
    NO: 1,

    /**
     * 名稱
     */
    NAME: 2,

})
